export default "/images/5.svg?bf80c2560e5a5e60e31f66f3ff61b7d5";